<div class="container mt-3">
  <h4>Filtrar pedidos de piensos</h4>
  <div class="row mb-3">
    <!-- filtros de fechas y cliente -->
    <div class="col-md-3 col-6 mb-2">
      <label>Desde:</label>
      <input type="date" class="form-control" [(ngModel)]="primerafecha" />
    </div>
    <div class="col-md-3 col-6 mb-2">
      <label>Hasta:</label>
      <input type="date" class="form-control" [(ngModel)]="ultimafecha" />
    </div>

    <div class="col-md-3 col-6 mb-2">
      <label>Cliente:</label>
      <input
        type="text"
        class="form-control mb-2"
        placeholder="Buscar cliente..."
        [(ngModel)]="filtroCliente"
      />
      <select class="form-control" [(ngModel)]="clienteSeleccionado">
        <option value="0" disabled selected>Seleccione un cliente...</option>
        <option
          *ngFor="let cli of clientes | clienteFilter: filtroCliente"
          [value]="cli.ttSocio"
        >
          {{ cli.ttNombr }}
        </option>
      </select>
    </div>

    <div class="col-md-2 col-6 d-flex align-items-end mb-2">
      <button class="btn btn-primary w-100" (click)="cargarPiensos()">
        Buscar
      </button>
    </div>

    <div class="col-md-2 col-6 d-flex align-items-end mb-2">
      <button
        class="btn btn-warning w-100"
        *ngIf="tablaPivotada.length > 0"
        (click)="activarBorrado()"
      >
        {{ modoBorrar ? "Cancelar" : "Editar/Borrar" }}
      </button>
    </div>

    <div class="col-md-4 col-12 d-flex align-items-end mb-2">
      <button
        class="btn btn-success w-100"
        (click)="exportarAExcel()"
        [disabled]="tablaPivotada.length === 0"
      >
        <fa-icon [icon]="['fas', 'file-excel']"></fa-icon> Exportar a Excel
      </button>
    </div>
  </div>
</div>

<div class="table-wrapper container-fluid mt-3 d-none d-md-block">
  <div *ngIf="tablaPivotada.length > 0">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th rowspan="2">FECHA</th>
          <th rowspan="2">NOMBRE</th>
          <th rowspan="2">FINCA</th>
          <th rowspan="2">FORMATO</th>
          <th rowspan="2">PEDIDO</th>
          <th rowspan="2">SERVIDO</th>
          <ng-container *ngFor="let marca of marcasTipos">
            <th [attr.colspan]="marca.tipos.length" class="text-center">
              {{ marca.ttdesmar }}
            </th>
          </ng-container>
          <th *ngIf="modoBorrar" rowspan="2" class="text-center">Acción</th>
          <th *ngIf="modoBorrar" rowspan="2" class="text-center">
            Editar Cantidades
          </th>
        </tr>
        <tr>
          <ng-container *ngFor="let marca of marcasTipos">
            <th *ngFor="let tipo of marca.tipos" class="text-center">
              {{ tipo.ttdestip }}
            </th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let fila of tablaPivotada">
          <td>{{ fila.ttFecha }}</td>
          <td>{{ fila.ttNombr }}</td>
          <td>{{ fila.ttExplo }}</td>
          <td>{{ fila.ttForma === 0 ? "Envasado" : "Granel" }}</td>
          <td class="text-center">
            <input
              type="checkbox"
              [ngModel]="fila.ttPedido === 1"
              (ngModelChange)="
                fila.ttPedido = $event ? 1 : 0;
                actualizarCampo(fila, 'ttPedido')
              "
            />
          </td>
          <td class="text-center">
            <input
              type="checkbox"
              [ngModel]="fila.ttServido === 1"
              (ngModelChange)="
                fila.ttServido = $event ? 1 : 0;
                actualizarCampo(fila, 'ttServido')
              "
            />
          </td>

          <ng-container *ngFor="let marca of marcasTipos">
            <td *ngFor="let tipo of marca.tipos" class="text-center">
              <span *ngIf="!fila.editandoCantidades">
                {{ obtenerCantidad(fila, marca, tipo) }}
              </span>
              <input
                *ngIf="fila.editandoCantidades"
                type="number"
                min="0"
                class="form-control form-control-sm"
                [(ngModel)]="fila[marca.ttdesmar + ' ' + tipo.ttdestip]"
              />
            </td>
          </ng-container>

          <td *ngIf="modoBorrar" class="text-center">
            <button
              class="btn btn-outline-danger btn-sm"
              (click)="borrarFila(fila)"
            >
              Borrar
            </button>
          </td>
          <td *ngIf="modoBorrar" class="text-center">
            <button
              *ngIf="!fila.editandoCantidades"
              class="btn btn-outline-primary btn-sm"
              (click)="editarCantidades(fila)"
            >
              Editar Cantidades
            </button>
            <span *ngIf="fila.editandoCantidades">
              <button
                class="btn btn-success btn-sm me-1"
                (click)="guardarCantidades(fila)"
              >
                Guardar
              </button>
              <button
                class="btn btn-secondary btn-sm"
                (click)="cancelarEdicion(fila)"
              >
                Cancelar
              </button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Cards Mobile -->
<div class="container mt-3 d-md-none" *ngIf="tablaPivotada.length > 0">
  <div class="row">
    <div class="col-12 mb-3" *ngFor="let fila of tablaPivotada">
      <div class="card pedido-card shadow-sm">
        <div class="card-body">
          <p><strong>Fecha:</strong> {{ fila.ttFecha }}</p>
          <p><strong>Nombre:</strong> {{ fila.ttNombr }}</p>
          <p><strong>Finca:</strong> {{ fila.ttExplo }}</p>
          <p>
            <strong>Formato:</strong>
            {{ fila.ttForma === 0 ? "Envasado" : "Granel" }}
          </p>

          <div *ngFor="let marca of marcasTipos" class="mb-2">
            <p>
              <strong>{{ marca.ttdesmar }}</strong>
            </p>
            <ul class="list-unstyled ms-3">
              <li *ngFor="let tipo of marca.tipos">
                {{ tipo.ttdestip }}:
                <span *ngIf="!fila.editandoCantidades" class="text-primary">
                  {{ obtenerCantidad(fila, marca, tipo) }}
                </span>
                <input
                  *ngIf="fila.editandoCantidades"
                  type="number"
                  min="0"
                  class="form-control form-control-sm mt-1"
                  [(ngModel)]="fila[marca.ttdesmar + ' ' + tipo.ttdestip]"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="d-flex mt-2">
          <button
            *ngIf="!fila.editandoCantidades"
            class="btn btn-outline-primary btn-sm me-1"
            (click)="editarCantidades(fila)"
          >
            Editar Cantidades
          </button>
          <span *ngIf="fila.editandoCantidades">
            <button
              class="btn btn-success btn-sm me-1"
              (click)="guardarCantidades(fila)"
            >
              Guardar
            </button>
            <button
              class="btn btn-secondary btn-sm"
              (click)="cancelarEdicion(fila)"
            >
              Cancelar
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>

  <ng-template #sinDatos>
    <div class="alert alert-info">No hay pedidos en el rango seleccionado</div>
  </ng-template>
</div>
